/**
 * Creates a single circle button for the Likert scale
 *
 * @prop {int} gradeNumber - Number to be rendered inside the button
 * @prop {string} descText - Text to be rendered under the button
 * @prop {boolean} selected - Indicated whether the current button is selected, aka different color
 * @prop {function} onClick - Function that is called when button is clicked
 *
 * @returns Circular numbered button that can be clicked
 */

import React from 'react';
import PropTypes from 'prop-types';
import Paper from 'material-ui/Paper';
import { Row, Col } from 'react-flexbox-grid';

import classes from './Grade.less';

const gradeSelected = sel => ({
  color: sel ? '#ffffff' : '#000000',
  backgroundColor: sel ? '#048b82' : '#ffffff',
});

const LikertGrade = ({ gradeNumber, descText, selected, onClick }) => (
  <div className={classes.gradeWrapper} onClick={onClick ? e => onClick(gradeNumber) : null}>
    <Paper style={gradeSelected(selected)} className={classes.grade} zDepth={1} circle>
      <Row middle="xs" className={classes.gradeText}>
        <Col xs>{gradeNumber}</Col>
      </Row>
    </Paper>
    <Row center="xs" className={classes.description}>
      {descText}
    </Row>
    {/* Text on side for smaller screens */}
    <Col xs className={classes.descriptionSmall}>
      <div style={{ width: '90px' }}>{descText}</div>
    </Col>
  </div>
);

LikertGrade.propTypes = {
  gradeNumber: PropTypes.number.isRequired,
  descText: PropTypes.string,
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
};

export default LikertGrade;
